import {
    RECEIVED_WISH_INFO,
    RECEIVED_CART_INFO,
    RECEIVED_COMPARE_INFO,
    SHOW_CART_COMPARE_LOADER,
    HIDE_CART_COMPARE_LOADER,
    SET_COMPARE_DEEP_DATA,
    CHANGE_COMMENT_ACTION, CHANGE_PRESENT_COMMENT_ACTION,
    CLEAR_ITEM_COMMENT
} from '../actions/wishCompareCart';



const initialState = {
    wishData: {},
    cartData: {},
    compareData: {},
    isShowCompareCartWishLoader: true,
    compareDeepData: [],
    compareList: {},
    commentsItems: {}
};

export default function wishCompareCart(state = initialState, action){
    switch ( action.type ) {
        case RECEIVED_WISH_INFO:
            return {
                ...state,
                wishData: action.data
            }
            break;

        case RECEIVED_CART_INFO:
            return {
                ...state,
                cartData: action.data
            }
            break;

        case RECEIVED_COMPARE_INFO:
            return {
                ...state,
                compareData: action.data
            }
            break;

        case SHOW_CART_COMPARE_LOADER:
            return {
                ...state,
                isShowCompareCartWishLoader: true
            }
            break;

        case HIDE_CART_COMPARE_LOADER:
            return {
                ...state,
                isShowCompareCartWishLoader: false,

            }
            break;
        case SET_COMPARE_DEEP_DATA:
            return {
                ...state,
                compareDeepData: action.data
            }
            break;

        case CHANGE_COMMENT_ACTION:
            return {
                ...state,
                commentsItems: Object.assign({}, state.commentsItems, {[action.item]: action.comment} ),
            }
            break;

        case CLEAR_ITEM_COMMENT:
            return {
                ...state,
                commentsItems: {}
            }
            break;
        case CHANGE_PRESENT_COMMENT_ACTION:
            var newCartData = Object.assign({},state.cartData);
            newCartData.data[action.item]['comments'] = action.comment;
            return {
                ...state,
                cartData: newCartData
            }
            break;
        default:
            return state;
    }
}